import styled from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors, ScreenDepth } from "@ryde/theme";

/*
 * a11y-exception: the handle is 8px wide, not 44px, because a wider strip would cover the header text and its
 * sort menu. The arrow keys resize the column from the focused handle as an alternative to dragging.
 */
export const ColumnResizeHandleStyled = styled.span.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "column-resize-handle",
})`
  position: absolute;
  top: 0;
  bottom: 0;
  inset-inline-end: 0;
  width: 8px;
  cursor: col-resize;
  touch-action: none;
  user-select: none;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    inset-inline-end: 0;
    width: 1px;
    background-color: ${greyMui._300};
  }

  &:hover::after,
  &.is_resizing::after {
    width: 2px;
    background-color: ${rydeColors.dragBorderColor};
  }

  /* While dragging, the line runs down the whole column; its length is measured when the drag starts. */
  &.is_resizing {
    z-index: ${ScreenDepth.GRID_SPLITTER};
  }

  &.is_resizing::after {
    bottom: auto;
    height: var(--column-resize-line-height, 100%);
  }

  &:focus-visible {
    outline: 2px solid ${rydeColors.focusedControl};
    outline-offset: -2px;
  }
`;
